<template>
  <div id="appStatisticsVueComponent" class="appFontBlack">

    <br>
    <div class="appCollectionPaiement">
      <h2>Paiement</h2>
      <br>
      <h2>Liste des encaissements en cours</h2>
      <div :key="index" v-for="(invoice, index) in filteredInvoice" class="appClientCardList appHoverEffect">
        <div @click.prevent="selectCollectionForPaiement(invoice._id)" class="appClientCardListSelect">
          <div class="appClientCardListLine1">
            <p>{{ invoice.client }}</p>
            <p>{{ invoice.totalprice }} €</p>
          </div>
        </div>
      </div>
      <h2>Encaissement Sélectionné</h2>

      <div class="appCollectionSection">
        <div class="appCollectionSectionDivisions1">
          <p>Nom - Prénom :</p>
        </div>
        <div class="appCollectionSectionDivisions1">
          <p id="idNameClientPaiement">{{ invoice.client }}</p>
        </div>
      </div>
      <br>

      <div class="appCollectionPanier">
        <div class="appCollectionPanierTitle">
          <p class="appCollectionWidth2">Qté</p>
          <p class="appCollectionWidth2">Catégorie</p>
          <p class="appCollectionWidth2">Sexe</p>
          <p class="appCollectionWidth2">Taille</p>
          <p class="appCollectionWidth3">Désignation</p>
          <p class="appCollectionWidth4">Prix</p>
          <p class="appCollectionWidth2">Total</p>
        </div>
        <div id="listOfItems"></div>
      </div>

      <div class="appCollectionSection">
        <div class="appCollectionSectionDivisions1">
          <p>Prestations :</p>
          <p>Prestations (€) :</p>
          <p>Ventes :</p>
          <p>Ventes (€) :</p>
          <p>Remise (€) :</p>
          <br>
          <p>Avant réduction :</p>
          <p>Base réduction :</p>
          <p>Réduction (%) :</p>
          <p>Réduction (€) :</p>
          <br>
          <p class="appCollectionWidthBold appCollectionTotalAspect">Total HT à régler :</p>
        </div>
        <div class="appCollectionSectionDivisions1">
          <p id="totalNbPrestations">0</p>
          <p id="totalCostPrestations">0</p>
          <p id="totalNbProducts">0</p>
          <p id="totalCostProducts">0</p>
          <p id="totalRemise">0</p>
          <br>
          <p id="totalBeforeReduction">0</p>
          <p id="totalAmountforReduction">0</p>
          <p id="totalReductionPourcent">0</p>
          <p id="totalReductionCost">0</p>
          <br>
          <p class="appCollectionWidthBold appCollectionTotalAspect" id="totalCostsOfPanier">0</p>
        </div>
      </div>

      <br>
      <h2>Mode de paiement</h2>

      <div class="appCollectionButtonSelection">
        <button @click.prevent="show_ModeUnique()" type="submit" class="appButtonModel3">Unique</button>
        <button @click.prevent="show_ModeMultiple()" type="submit" class="appButtonModel3">Multiple</button>
      </div>

      <div id="appPaiementUnique">
        <div class="appCollectionSection2">
          <h3>Mode de paiement unique</h3>
          <button @click.prevent="fullEspeces()" class="appButtonModel2">Espèces</button>
          <button @click.prevent="fullCheques()" class="appButtonModel2">Chèques</button>
          <button @click.prevent="fullCB()" class="appButtonModel2">CB</button>
          <button @click.prevent="fullPaylib()" class="appButtonModel2">Virement</button>
          <button @click.prevent="fullPaypal()" class="appButtonModel2">Paypal</button>
          <br>
          <br>
          <button @click.prevent="unshow_Modes()" type="submit" class="appButtonModel3">^</button>
        </div>
      </div>

      <div id="appPaiementMultiple">
        <div class="appCollectionSection2">
          <h3>Mode de paiement Multiple</h3>
          <br>
          <div class="appcollectionPaiementCategoriesBloc">
            <p>Espèces</p>
            <input v-model="amountEspeces" id="amountEspeces" type="number" step=".01" name="priceEspeces"
              class="appInputStyle4" placeholder=0>
          </div>
          <div class="appcollectionPaiementCategoriesBloc">
            <p>Chèques</p>
            <input v-model="amountCheques" id="amountCheques" type="number" step=".01" name="priceCheques"
              class="appInputStyle4" placeholder=0>
          </div>
          <div class="appcollectionPaiementCategoriesBloc">
            <p>CB</p>
            <input v-model="amountCB" id="amountCB" type="number" step=".01" name="priceCB" class="appInputStyle4"
              placeholder=0>
          </div>
          <div class="appcollectionPaiementCategoriesBloc">
            <p>Virement</p>
            <input v-model="amountPaylib" id="amountPaylib" type="number" step=".01" name="pricePaylib"
              class="appInputStyle4" placeholder=0>
          </div>
          <div class="appcollectionPaiementCategoriesBloc">
            <p>Paypal</p>
            <input v-model="amountPaypal" id="amountPaypal" type="number" step=".01" name="pricePaypal"
              class="appInputStyle4" placeholder=0>
          </div>
          <div v-show="errorMsg" class="error" id="errordiv">{{ errorMsg }}</div>
          <br>
          <button @click.prevent="unshow_Modes()" type="submit" class="appButtonModel3">^</button>
        </div>
      </div>
    </div>
    <div class="appCollectionSection">
      <div class="appCollectionSectionDivisions1">
        <p>Mode de paiement</p>
      </div>
      <div class="appCollectionSectionDivisions1">
        <p id="appInvoiceModePaiement"></p>
      </div>
    </div>
    <br>
    <button @click.prevent="createInvoice()" type="submit" class="appButtonModel2">Valider le paiement</button>
    <button @click.prevent="cancelcreateInvoice()" type="submit" class="appButtonModel2">Retourner à
      l'encaissement</button>
  <br>
  <br>
</div></template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  name: 'appCollectionPaiement',
  data () {
    return {
      invoice: '',
      errorMsg: '',
      amountEspeces: '',
      amountCheques: '',
      amountCB: '',
      amountPaylib: '',
      amountPaypal: ''
    }
  },
  updated () {
    this.calculateTotal()
  },
  mounted () {
    this.listInvoicesCode1()
    this.unshow_Modes()
  },
  computed: {
    filteredInvoice () {
      if (this.invoice.length > 0) {
        return this.invoice.filter(item => item.categoryOfInvoice === 1)
      }
    }
  },
  methods: {
    show_ModeUnique () {
      document.getElementById('appPaiementUnique').style.display = 'inline'
      document.getElementById('appPaiementMultiple').style.display = 'none'
    },
    show_ModeMultiple  () {
      document.getElementById('appPaiementUnique').style.display = 'none'
      document.getElementById('appPaiementMultiple').style.display = 'inline'
    },
    unshow_Modes () {
      document.getElementById('appPaiementUnique').style.display = 'none'
      document.getElementById('appPaiementMultiple').style.display = 'none'
    },
    listInvoicesCode1 () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.invoice = response.data
        })
    },
    selectCollectionForPaiement (id) {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/factures/' + id), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.invoice = response.data
          let mySelectionSettings = []
          const cartLines = JSON.stringify(response.data.lines)
          const cartSetting =
        {
          statut: 'Modification',
          factureId: response.data._id,
          factureUserId: response.data.userId,
          reduction: response.data.reduction,
          technicalData: response.data.technicalData
        }
          mySelectionSettings.push(cartSetting)
          localStorage.setItem('orderPrivilegiaSettings', JSON.stringify(mySelectionSettings))
          localStorage.setItem('orderPrivilegia', cartLines)
          this.showFinalPanier()
        })
    },
    showFinalPanier () {
      if (localStorage.getItem('orderPrivilegia') === null) {
        return
      }
      // Effacer valeurs
      let listToRemove = document.getElementById('listOfItems')
      if (listToRemove != null) {
        while (listToRemove.firstChild) {
          listToRemove.removeChild(listToRemove.firstChild)
        }
      }
      // Regénérer les valeurs
      if (localStorage.getItem('orderPrivilegiaSettings') !== null) {
        document.getElementById('totalReductionPourcent').innerText = JSON.parse(localStorage.getItem('orderPrivilegiaSettings'))[0].reduction + '%'
      }
      var myTotalCounter = JSON.parse(localStorage.getItem('orderPrivilegia')).length
      var totalNbPrestations = 0
      var totalCostPrestations = 0
      var totalNbProducts = 0
      var totalCostProducts = 0
      var totalRemise = 0
      var totalBeforeReduction = 0
      var totalAmountforReduction = 0
      for (let myCounter = 0; myCounter < myTotalCounter; myCounter++) {
        var myLocalStorage = localStorage.getItem('orderPrivilegia')
        var myLocalStorageJSON = JSON.parse(myLocalStorage)
        const textCategory = myLocalStorageJSON[myCounter].category
        const textSexe = myLocalStorageJSON[myCounter].sexe
        const textSize = myLocalStorageJSON[myCounter].size
        const textDesignation = myLocalStorageJSON[myCounter].designation
        const textQuantity = myLocalStorageJSON[myCounter].quantity
        const textPrice = myLocalStorageJSON[myCounter].price
        const textTotal = myLocalStorageJSON[myCounter].total
        // Créer carte
        // Créer le div de l'item
        let newDivItem = document.createElement('div')
        newDivItem.className = 'appCollectionPanierItems'
        // Créer les classes
        let newPCategory = document.createElement('p')
        newPCategory.className = 'appCollectionWidth4'
        newPCategory.innerText = textCategory
        let newPSexe = document.createElement('p')
        newPSexe.className = 'appCollectionWidth4'
        newPSexe.innerText = textSexe
        let newPSize = document.createElement('p')
        newPSize.className = 'appCollectionWidth2'
        newPSize.innerText = textSize
        let newPDesignation = document.createElement('p')
        newPDesignation.className = 'appCollectionWidth3'
        newPDesignation.innerText = textDesignation
        // Créer le prix unitaire avec mise en forme
        let newPPrice = document.createElement('p')
        newPPrice.className = 'appCollectionWidth2'
        const currencyPrice = function (textTotal) {
          return new Intl.NumberFormat('FR-fr', {style: 'currency', currency: 'EUR', minimumFractionDigits: 2}).format(textTotal).replace('€', '')
        }
        const textPriceCurrency = currencyPrice(textPrice)
        newPPrice.innerText = textPriceCurrency
        // Créer le prix total avec mise en forme
        let newPTotal = document.createElement('p')
        newPTotal.className = 'appCollectionPanierItems appCollectionWidthBold'
        const currencyTotal = function (textTotal) {
          return new Intl.NumberFormat('FR-fr', {style: 'currency', currency: 'EUR', minimumFractionDigits: 2}).format(textTotal)
        }
        const textTotalCurrency = currencyTotal(textTotal)
        newPTotal.innerText = textTotalCurrency
        // Créer la quantité - hors format Input
        let newPQuantity = document.createElement('p')
        newPQuantity.className = 'appCollectionWidth2 appCollectionWidthBold'
        newPQuantity.innerText = textQuantity
        // Intégrer dans le HTML
        document.getElementById('listOfItems').appendChild(newDivItem)
        newDivItem.appendChild(newPQuantity)
        newDivItem.appendChild(newPCategory)
        newDivItem.appendChild(newPSexe)
        newDivItem.appendChild(newPSize)
        newDivItem.appendChild(newPDesignation)
        newDivItem.appendChild(newPPrice)
        newDivItem.appendChild(newPTotal)
        // Actualiser valeurs de l'encart "Total"
        if (myLocalStorageJSON[myCounter].category === 'Prestation') {
          totalNbPrestations = totalNbPrestations + myLocalStorageJSON[myCounter].quantity
          document.getElementById('totalNbPrestations').innerText = totalNbPrestations
        }
        if (myLocalStorageJSON[myCounter].category === 'Prestation') {
          totalCostPrestations = totalCostPrestations + myLocalStorageJSON[myCounter].total
          document.getElementById('totalCostPrestations').innerText = totalCostPrestations.toFixed(2) + ' €'
        }
        if (myLocalStorageJSON[myCounter].category === 'Vente') {
          totalNbProducts = totalNbProducts + myLocalStorageJSON[myCounter].quantity
          document.getElementById('totalNbProducts').innerText = totalNbProducts
        }
        if (myLocalStorageJSON[myCounter].category === 'Vente') {
          totalCostProducts = totalCostProducts + myLocalStorageJSON[myCounter].total
          document.getElementById('totalCostProducts').innerText = totalCostProducts.toFixed(2) + ' €'
        }
        if (myLocalStorageJSON[myCounter].category === 'Remise') {
          totalRemise = totalRemise + myLocalStorageJSON[myCounter].total
          document.getElementById('totalRemise').innerText = totalRemise + ' €'
        }
        if (myLocalStorageJSON[myCounter].category === 'Prestation' && myLocalStorageJSON[myCounter].sexe !== 'enfant') {
          totalAmountforReduction = totalAmountforReduction + myLocalStorageJSON[myCounter].total
          document.getElementById('totalAmountforReduction').innerText = totalAmountforReduction.toFixed(2) + ' €'
        }
        totalBeforeReduction = totalCostPrestations + totalCostProducts + totalRemise
        document.getElementById('totalBeforeReduction').innerText = totalBeforeReduction.toFixed(2) + ' €'
      }
      let reductionData = parseInt(document.getElementById('totalReductionPourcent').outerText)
      if (reductionData === 0) {
        document.getElementById('totalReductionPourcent').innerText = 0
        document.getElementById('totalReductionCost').innerText = 0 + ' €'
        document.getElementById('totalCostsOfPanier').innerText = totalBeforeReduction.toFixed(2) + ' €'
      } else {
        let reduction = reductionData / 100
        var totalReductionCost = (totalAmountforReduction * reduction)
        document.getElementById('totalReductionCost').innerText = totalReductionCost.toFixed(2) + ' €'
        var totalCostsOfPanier = totalBeforeReduction - totalReductionCost
        document.getElementById('totalCostsOfPanier').innerText = totalCostsOfPanier.toFixed(2) + ' €'
      }
      // Rectifier si valeur à 0
      if (totalNbPrestations === 0) {
        document.getElementById('totalNbPrestations').innerText = totalNbPrestations
        document.getElementById('totalCostPrestations').innerText = totalCostPrestations.toFixed(2) + ' €'
      }
      if (totalNbProducts === 0) {
        document.getElementById('totalNbProducts').innerText = totalNbProducts
        document.getElementById('totalCostProducts').innerText = totalCostProducts.toFixed(2) + ' €'
      }
      if (totalRemise === 0) {
        document.getElementById('totalRemise').innerText = totalRemise + ' €'
      }
    },
    fullEspeces () {
      document.getElementById('appInvoiceModePaiement').innerText = 'Totalité en Espèces'
      this.unshow_Modes()
    },
    fullCheques () {
      document.getElementById('appInvoiceModePaiement').innerText = 'Totalité en Chèques'
      this.unshow_Modes()
    },
    fullCB () {
      document.getElementById('appInvoiceModePaiement').innerText = 'Totalité en Carte bancaire'
      this.unshow_Modes()
    },
    fullPaylib () {
      document.getElementById('appInvoiceModePaiement').innerText = 'Totalité via Virement'
      this.unshow_Modes()
    },
    fullPaypal () {
      document.getElementById('appInvoiceModePaiement').innerText = 'Totalité via Paypal'
      this.unshow_Modes()
    },
    calculateTotal () {
      // Lancer le calcul
      let costEspeces = 0
      let costCheques = 0
      let costCB = 0
      let costPaylib = 0
      let costPaypal = 0
      if (!this.amountEspeces) {
        costEspeces = 0
      } else {
        costEspeces = parseFloat(this.amountEspeces)
      }
      if (!this.amountCheques) {
        costCheques = 0
      } else {
        costCheques = parseFloat(this.amountCheques)
      }
      if (!this.amountCB) {
        costCB = 0
      } else {
        costCB = parseFloat(this.amountCB)
      }
      if (!this.amountPaylib) {
        costPaylib = 0
      } else {
        costPaylib = parseFloat(this.amountPaylib)
      }
      if (!this.amountPaypal) {
        costPaypal = 0
      } else {
        costPaypal = parseFloat(this.amountPaypal)
      }
      let sumOfAmounts = costEspeces + costCheques + costCB + costPaylib + costPaypal
      let totalHTToCompare = parseFloat(document.getElementById('totalCostsOfPanier').innerText)
      let difference = (totalHTToCompare - sumOfAmounts)
      if (difference !== 0) {
        this.errorMsg = 'Restant : ' + difference.toFixed(2) + ' €'
      } else {
        this.errorMsg = ''
      }
      // Ajuster le mode de paiement
      var textEspeces = ''
      var textCheques = ''
      var textCB = ''
      var textPaylib = ''
      var textPaypal = ''
      if (!this.amountEspeces) {
        textEspeces = ''
      } else {
        textEspeces = 'Espèces'
      }
      if (!this.amountCheques) {
        textCheques = ''
      } else {
        textCheques = 'Chèque'
      }
      if (!this.amountCB) {
        textCB = ''
      } else {
        textCB = 'Carte Bancaire'
      }
      if (!this.amountPaylib) {
        textPaylib = ''
      } else {
        textPaylib = 'Virement'
      }
      if (!this.amountPaypal) {
        textPaypal = ''
      } else {
        textPaypal = 'Paypal'
      }
      var finalText = textEspeces + ' ' + textCheques + ' ' + textCB + ' ' + textPaylib + ' ' + textPaypal
      document.getElementById('appInvoiceModePaiement').innerText = finalText
    },
    cancelcreateInvoice () {
      localStorage.removeItem('orderPrivilegia')
      localStorage.removeItem('orderPrivilegiaSettings')
      this.$router.push('/App/Collection')
    },
    reset () {
      window.location.reload()
    },
    async createInvoice () {
      if (confirm('Valider ma facture ?')) {
        let codeBlocage = 0
        let finaltypeofpaiement = 0
        let finalpaiementEspeces = 0
        let finalpaiementCheques = 0
        let finalpaiementCB = 0
        let finalpaiementPaylib = 0
        let finalpaiementPaypal = 0
        let codeFacture = 0
        // Vérifier si encaissement sélectionné
        if (!parseFloat(document.getElementById('totalCostsOfPanier').innerText)) {
          window.alert('Aucun encaissement sélectionné')
        } else {
        // Vérifier si Mode de paiement rempli
          if (!document.getElementById('appInvoiceModePaiement').innerText) {
            window.alert('Aucun mode de paiement sélectionné')
          } else {
          // Vérifier si montants OK
            if (document.getElementById('appInvoiceModePaiement').innerText === 'Totalité en Espèces') {
              finaltypeofpaiement = 'Espèces'
              finalpaiementEspeces = parseFloat(document.getElementById('totalCostsOfPanier').innerText)
              finalpaiementCheques = 0
              finalpaiementCB = 0
              finalpaiementPaylib = 0
              finalpaiementPaypal = 0
              codeBlocage = 0
            } else {
              if (document.getElementById('appInvoiceModePaiement').innerText === 'Totalité en Chèques') {
                finaltypeofpaiement = 'Chèques'
                finalpaiementEspeces = 0
                finalpaiementCheques = parseFloat(document.getElementById('totalCostsOfPanier').innerText)
                finalpaiementCB = 0
                finalpaiementPaylib = 0
                finalpaiementPaypal = 0
                codeBlocage = 0
              } else {
                if (document.getElementById('appInvoiceModePaiement').innerText === 'Totalité en Carte bancaire') {
                  finaltypeofpaiement = 'CB'
                  finalpaiementEspeces = 0
                  finalpaiementCheques = 0
                  finalpaiementCB = parseFloat(document.getElementById('totalCostsOfPanier').innerText)
                  finalpaiementPaylib = 0
                  finalpaiementPaypal = 0
                  codeBlocage = 0
                } else {
                  if (document.getElementById('appInvoiceModePaiement').innerText === 'Totalité via Virement') {
                    finaltypeofpaiement = 'Virement'
                    finalpaiementEspeces = 0
                    finalpaiementCheques = 0
                    finalpaiementCB = 0
                    finalpaiementPaylib = parseFloat(document.getElementById('totalCostsOfPanier').innerText)
                    finalpaiementPaypal = 0
                    codeBlocage = 0
                  } else {
                    if (document.getElementById('appInvoiceModePaiement').innerText === 'Totalité via Paypal') {
                      finaltypeofpaiement = 'Paypal'
                      finalpaiementEspeces = 0
                      finalpaiementCheques = 0
                      finalpaiementCB = 0
                      finalpaiementPaylib = 0
                      finalpaiementPaypal = parseFloat(document.getElementById('totalCostsOfPanier').innerText)
                      codeBlocage = 0
                    } else { // ajouter les valeurs multiples
                      let totalToCompare = parseFloat(document.getElementById('totalCostsOfPanier').innerText)
                      let finalpaiementEspeces00 = 0
                      let finalpaiementCheques00 = 0
                      let finalpaiementCB00 = 0
                      let finalpaiementPaylib00 = 0
                      let finalpaiementPaypal00 = 0
                      if (isNaN(parseFloat(document.getElementById('amountEspeces').value))) { finalpaiementEspeces00 = 0 } else { finalpaiementEspeces00 = parseInt(document.getElementById('amountEspeces').value) }
                      if (isNaN(parseFloat(document.getElementById('amountCheques').value))) { finalpaiementCheques00 = 0 } else { finalpaiementCheques00 = parseFloat(document.getElementById('amountCheques').value) }
                      if (isNaN(parseFloat(document.getElementById('amountCB').value))) { finalpaiementCB00 = 0 } else { finalpaiementCB00 = parseFloat(document.getElementById('amountCB').value) }
                      if (isNaN(parseFloat(document.getElementById('amountPaylib').value))) { finalpaiementPaylib00 = 0 } else { finalpaiementPaylib00 = parseFloat(document.getElementById('amountPaylib').value) }
                      if (isNaN(parseFloat(document.getElementById('amountPaypal').value))) { finalpaiementPaypal00 = 0 } else { finalpaiementPaypal00 = parseFloat(document.getElementById('amountPaypal').value) }
                      finaltypeofpaiement = document.getElementById('appInvoiceModePaiement').innerText
                      finalpaiementEspeces = finalpaiementEspeces00
                      finalpaiementCheques = finalpaiementCheques00
                      finalpaiementCB = finalpaiementCB00
                      finalpaiementPaylib = finalpaiementPaylib00
                      finalpaiementPaypal = finalpaiementPaypal00
                      let totalOfInputs = finalpaiementEspeces + finalpaiementCheques + finalpaiementCB + finalpaiementPaylib + finalpaiementPaypal
                      if (totalToCompare - totalOfInputs !== 0) {
                        codeBlocage = 1
                      } else {
                        codeBlocage = 0
                      }
                    }
                  }
                }
              }
            }
            // Si codeBlocage 1 => annuler
            if (codeBlocage === 1) {
              alert('La répartition des montants ne correspond pas au total à payer')
            } else {
            // Si codeBlocage 0 => continuer
              // Proposer de déclarer ou non
              if (confirm('Enregistrer ?')) {
                codeFacture = 2
              } else {
                codeFacture = 3
              }
              // Compter factures en "2" et en "3"
              const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
              let mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
              let idFacture = JSON.parse(localStorage.getItem('orderPrivilegiaSettings'))[0].factureId
              let idUserFacture = JSON.parse(localStorage.getItem('orderPrivilegiaSettings'))[0].factureUserId
              let technicalDataToSave = JSON.parse(localStorage.getItem('orderPrivilegiaSettings'))[0].technicalData
              // Décrémenter les stocks => probleme ne traite que le dernier
              var myTotalCounter = JSON.parse(localStorage.getItem('orderPrivilegia')).length
              for (let myCounterProduct = 0; myCounterProduct < myTotalCounter; myCounterProduct++) {
                if (mySelection[myCounterProduct].category === 'Vente') {
                  var myCodeProduct = mySelection[myCounterProduct].codeID
                  var myCodeQuantity = mySelection[myCounterProduct].quantity
                  await axios
                    .get(('https://privilegia.fr/api/produits/' + myCodeProduct), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
                    .then((response) => {
                      this.product = response.data
                      var myPreviousQuantity = this.product.quantity
                      axios
                        .put('https://privilegia.fr/api/produits/' + myCodeProduct,
                          {'quantity': myPreviousQuantity - myCodeQuantity},
                          { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
                    })
                }
              }
              // Trouver le numéro de facture
              axios
                .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
                .then((response) => {
                  let nbInvoice2 = response.data.filter(facture => facture.categoryOfInvoice === 2).length
                  let nbInvoice3 = response.data.filter(facture => facture.categoryOfInvoice === 3).length
                  let numberFacturetoUse = 0
                  if (codeFacture === 2) {
                    numberFacturetoUse = 200000 + nbInvoice2 + 1
                  }
                  if (codeFacture === 3) {
                    numberFacturetoUse = 800000 + nbInvoice3 + 1
                  }
                  // Effectuer l'enregistrement Facture
                  axios
                    .put('https://privilegia.fr/api/factures/' + idFacture,
                      { 'userId': idUserFacture,
                        'date': moment(Date.now()),
                        'number': numberFacturetoUse,
                        'client': document.getElementById('idNameClientPaiement').textContent,
                        'lines': mySelection,
                        'reduction': parseInt(document.getElementById('totalReductionPourcent').outerText),
                        'amountreduction': parseFloat(document.getElementById('totalReductionCost').outerText),
                        'typeofpaiement': finaltypeofpaiement,
                        'paiementEspeces': finalpaiementEspeces,
                        'paiementCheques': finalpaiementCheques,
                        'paiementCB': finalpaiementCB,
                        'paiementPaylib': finalpaiementPaylib,
                        'paiementPaypal': finalpaiementPaypal,
                        'totalprice': parseFloat(document.getElementById('totalCostsOfPanier').outerText),
                        'categoryOfInvoice': codeFacture,
                        'technicalData': technicalDataToSave,
                        'dateBank': '-'
                      }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
                    .then((response) => {
                      // Mettre à jour la fiche technique client
                      const cartTechnical =
                      {
                        date: moment(Date.now()).format('YYYY-MM-DD'),
                        text: technicalDataToSave,
                        invoiceId: idFacture,
                        invoiceNumber: numberFacturetoUse
                      }
                      axios
                        .get(('https://privilegia.fr/api/clients/' + idUserFacture), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
                        .then((response) => {
                          this.client = response.data
                          let arrayOfTechnical = this.client.technicalsDatas
                          arrayOfTechnical.push(cartTechnical)
                          axios
                            .put('https://privilegia.fr/api/clients/' + idUserFacture,
                              {
                                'technicalsDatas': arrayOfTechnical
                              }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
                        })
                      localStorage.removeItem('orderPrivilegia')
                      localStorage.removeItem('orderPrivilegiaSettings')
                      window.alert('Facture N°' + numberFacturetoUse + ' éditée')
                      this.$router.push('/App/Collection')
                    })
                })
            }
          }
        }
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppCollectionPaiement.vue